const BlogFilterByCate = {
    init() : void {
        // POST BY CATE
        const listCate = document.getElementById('list-cate');
        const posts = document.querySelectorAll<HTMLElement>('.section-news .news-content .post-by-cate .content .post');

        if (!listCate) {
            return;
        }

        const listCateChildren = listCate.children;
        const defaultCate = (listCateChildren[0].children[0] as HTMLElement).dataset.cate as string;

        if (listCateChildren.length > 0) {
            // Initialisation
            listCateChildren[0].classList.add('active');
            posts.forEach(function(post) {
                post.classList.remove('visible');
                post.classList.add('hidden');
            });

            const defaultPostsCate = document.getElementsByClassName(defaultCate);
            for (let i = 0; i < defaultPostsCate.length; i++) {
                defaultPostsCate[i].classList.remove('hidden');
                defaultPostsCate[i].classList.add('visible');
            }

            // Event click
            for (let j = 0; j < listCateChildren.length; j++) {
                const linkCate = listCateChildren[j];

                linkCate.addEventListener('click', () => {
                    for (let k = 0; k < listCateChildren.length; k++) {
                        listCateChildren[k].classList.remove('active');
                    }

                    linkCate.classList.add('active');

                    const cateTarget = (linkCate.children[0] as HTMLElement).dataset.cate as string;
                    posts.forEach(function(post) {
                        post.classList.remove('visible');
                        post.classList.add('hidden');
                    });

                    const postsCateTarget = document.getElementsByClassName(cateTarget);
                    for (let l = 0; l < postsCateTarget.length; l++) {
                        postsCateTarget[l].classList.remove('hidden');
                        postsCateTarget[l].classList.add('visible');
                    }
                });
            }
        }

        const $selectFilterCate = document.getElementById('cate-first-filter-resp');
        $selectFilterCate?.addEventListener('change', (evt) => {
            const cate = document.querySelectorAll<HTMLAnchorElement>('#list-cate a[href="' + (evt.target as HTMLInputElement).value + '"]');
            cate[0].click();
        });
    },
};

export default BlogFilterByCate;
